<template>
  <div class="login-container">
    <el-form
      ref="loginForm"
      :model="loginForm"
      :rules="loginRules"
      class="login-form"
      autocomplete="on"
      label-position="left"
    >
      <div class="title-container">
        <h3 class="title">商家系统</h3>
      </div>
      <el-form-item ref="businessCode" prop="businessCode" :class="{focus:focusCode}">
        <span class="svg-container">
          <svg-icon icon-class="qiye" />
        </span>
        <el-input
          v-model.trim="loginForm.businessCode"
          placeholder="请输入企业码"
          name="businessCode"
          type="text"
          tabindex="1"
          autocomplete="on"
          @focus="focusCode = true"
          @blur="focusCode = false"
        />
      </el-form-item>

      <el-form-item ref="loginName" prop="loginName" :class="{focus:focusName}">
        <span class="svg-container">
          <svg-icon icon-class="yonghu" />
        </span>
        <el-input
          v-model.trim="loginForm.loginName"
          placeholder="请输入用户名"
          type="text"
          tabindex="2"
          autocomplete="off"
          @focus="focusName = true"
          @blur="focusName = false"
        />
      </el-form-item>

      <el-tooltip
        v-model="capsTooltip"
        content="大写按键开启了"
        placement="right"
        manual
        :class="{focus:focusPwd}"
      >
        <el-form-item ref="password" prop="password">
          <span class="svg-container">
            <svg-icon icon-class="mima" />
          </span>
          <el-input
            ref="password"
            :key="passwordType"
            v-model="loginForm.password"
            :type="passwordType"
            placeholder="请输入密码"
            tabindex="3"
            autocomplete="off"
            @keyup.native="checkCapslock"
            @blur="capsTooltip = false,focusPwd = false"
            @focus="focusPwd = true"
            @keyup.enter.native="handleLogin"
          />
          <span class="show-pwd" @click="showPwd">
            <svg-icon :icon-class="passwordType === 'password' ? 'eye' : 'eye-open'" />
          </span>
        </el-form-item>
      </el-tooltip>

      <el-button
        class="submit"
        :loading="loading"
        type="primary"
        style="width:100%;margin-bottom:30px;"
        @click.native.prevent="handleLogin"
      >立即登录</el-button>
    </el-form>

    <!--    <el-dialog title="Or connect with" :visible.sync="showDialog">-->
    <!--      Can not be simulated on local, so please combine you own business simulation! ! !-->
    <!--      <br>-->
    <!--      <br>-->
    <!--      <br>-->
    <!--      <social-sign />-->
    <!--    </el-dialog>-->
  </div>
</template>

<script>
// import { validUsername } from '@/utils/validate'
// import SocialSign from './components/SocialSignin'

export default {
  name: 'Login',
  // components: { SocialSign },
  data() {
    // const validateUsername = (rule, value, callback) => {
    //   if (!validUsername(value)) {
    //     callback(new Error('请输入正确的用户名'))
    //   } else {
    //     callback()
    //   }
    // }
    // const validatePassword = (rule, value, callback) => {
    //   if (value.length < 6) {
    //     callback(new Error('密码不能少于6位'))
    //   } else {
    //     callback()
    //   }
    // }
    return {
      loginForm: {
        businessCode: '',
        loginName: '',
        password: ''
      },
      loginRules: {
        businessCode: [
          { required: true, trigger: 'blur', message: '企业码不能为空!' }
        ],
        loginName: [
          { required: true, trigger: 'blur', message: '用户名不能为空!' }
        ],
        password: [
          { required: true, trigger: 'blur', message: '密码不能为空!' }
        ]
      },
      passwordType: 'password',
      capsTooltip: false,
      loading: false,
      showDialog: false,
      redirect: undefined,
      otherQuery: {},
      focusCode: false,
      focusName: false,
      focusPwd: false
    }
  },
  watch: {
    $route: {
      handler: function(route) {
        const query = route.query
        if (query) {
          this.redirect = query.redirect
          this.otherQuery = this.getOtherQuery(query)
        }
      },
      immediate: true
    }
  },
  created() {
    // window.addEventListener('storage', this.afterQRScan)
  },
  mounted() {
    // if (this.loginForm.username === '') {
    //   this.$refs.username.focus()
    // } else if (this.loginForm.password === '') {
    //   this.$refs.password.focus()
    // }
  },
  destroyed() {
    // window.removeEventListener('storage', this.afterQRScan)
  },
  methods: {
    checkCapslock(e) {
      const { key } = e
      this.capsTooltip = key && key.length === 1 && key >= 'A' && key <= 'Z'
    },
    showPwd() {
      if (this.passwordType === 'password') {
        this.passwordType = ''
      } else {
        this.passwordType = 'password'
      }
      this.$nextTick(() => {
        this.$refs.password.focus()
      })
    },
    handleLogin() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.loading = true
          this.$store
            .dispatch('user/login', this.loginForm)
            .then(() => {
              this.$router.push({
                path: this.redirect || '/',
                query: this.otherQuery
              })
              this.loading = false
            })
            .catch((e) => {
              this.$errorHandle(e)
              // this.$message.error('登录失败!请检查账户信息!')
              this.loading = false
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    getOtherQuery(query) {
      return Object.keys(query).reduce((acc, cur) => {
        if (cur !== 'redirect') {
          acc[cur] = query[cur]
        }
        return acc
      }, {})
    }
    // afterQRScan() {
    //   if (e.key === 'x-admin-oauth-code') {
    //     const code = getQueryObject(e.newValue)
    //     const codeMap = {
    //       wechat: 'code',
    //       tencent: 'code'
    //     }
    //     const type = codeMap[this.auth_type]
    //     const codeName = code[type]
    //     if (codeName) {
    //       this.$store.dispatch('LoginByThirdparty', codeName).then(() => {
    //         this.$router.push({ path: this.redirect || '/' })
    //       })
    //     } else {
    //       alert('第三方登录失败')
    //     }
    //   }
    // }
  }
}
</script>

<style lang="scss">
/* 修复input 背景不协调 和光标变色 */
/* Detail see https://github.com/PanJiaChen/vue-element-admin/pull/927 */

$bg: #fff;
$light_gray: #333;
$cursor: #666;

@supports (-webkit-mask: none) and (not (cater-color: $cursor)) {
  .login-container .el-input input {
    color: $cursor;
  }
}

/* reset element-ui css */
.login-container {
  .el-input {
    display: inline-block;
    height: 47px;
    width: 85%;

    input {
      background: transparent;
      border: 0px;
      -webkit-appearance: none;
      border-radius: 0px;
      padding: 12px 5px 12px 15px;
      color: $light_gray;
      height: 47px;
      font-size: 16px;
      caret-color: $cursor;
      &:focus {
        /*color:Red*/
      }

      &:-webkit-autofill {
        box-shadow: 0 0 0px 1000px $bg inset !important;
        -webkit-text-fill-color: $cursor !important;
      }
    }
  }

  .el-form-item {
    position: relative;
    width: 300px;
    margin: auto;
    border-bottom: 1px solid #ebeef5;
    // background: rgba(0, 0, 0, 0.1);
    border-radius: 0;
    color: #454545;
    margin-top: 20px;
    &:after {
      content: '';
      display: block;
      position: absolute;
      left: 50%;
      bottom: 0;
      width: 0;
      height: 1px;
      background: #2b6fef;
      transition: all 300ms;
    }
    &.focus:after {
      left: 0;
      width: 100%;
    }
  }
}
</style>

<style lang="scss" scoped>
$bg: #2d3a4b;
$dark_gray: #889aa4;
$light_gray: #2b6fef;

.login-container {
  min-height: 100%;
  width: 100%;
  // background-color: $bg;
  background: url('~@/assets/images/bg.png') center no-repeat;
  background-image: image-set(
    url(~@/assets/images/bg.png) 1x,
    url(~@/assets/images/bg@2x.png) 2x
  );
  background-size: cover;
  overflow: hidden;

  .login-form {
    position: absolute;
    top: 50%;
    margin-top: -230px;
    left: 15%;
    width: 400px;
    height: 440px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 25px 2px rgba(218, 236, 255, 1);
    border-radius: 15px;
    padding: 0 20px;
  }

  .tips {
    font-size: 14px;
    color: #fff;
    margin-bottom: 10px;

    span {
      &:first-of-type {
        margin-right: 16px;
      }
    }
  }

  .svg-container {
    padding: 6px 5px 6px 15px;
    color: #3076f0;
    vertical-align: middle;
    width: 30px;
    font-size: 18px;
    display: inline-block;
  }
  .submit {
    width: 300px;
    height: 50px;
    background: rgba(43, 111, 239, 1);
    border-radius: 10px;
    box-shadow: 0px 2px 25px 2px rgba(218, 236, 255, 1);
    font-size: 18px;
    margin-top: 40px;
    font-weight: 500;
  }

  .title-container {
    position: relative;

    .title {
      font-size: 28px;
      line-height: 1;
      color: $light_gray;
      margin: 27px auto 0 auto;
      text-align: center;
      // font-weight: bold;
      padding-bottom: 24px;
      border-bottom: 1px solid #ebeef5;
    }
  }

  .show-pwd {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 16px;
    color: $dark_gray;
    cursor: pointer;
    user-select: none;
  }

  .thirdparty-button {
    position: absolute;
    right: 0;
    bottom: 6px;
  }

  @media only screen and (max-width: 470px) {
    .thirdparty-button {
      display: none;
    }
  }
}
</style>
